var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3F444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8479 33.9099H17.1615C15.4183 33.9099 14 32.4881 14 30.7405V26.0425C14 24.2949 15.4183 22.873 17.1615 22.873H21.8479C23.5912 22.873 25.0095 24.2949 25.0095 26.0425V30.7405C25.0095 32.4881 23.5912 33.9099 21.8479 33.9099ZM17.1615 24.2C16.1483 24.2 15.3237 25.0267 15.3237 26.0425V30.7405C15.3237 31.7563 16.1483 32.583 17.1615 32.583H21.8479C22.8612 32.583 23.6858 31.7563 23.6858 30.7405V26.0425C23.6858 25.0267 22.8612 24.2 21.8479 24.2H17.1615Z",
    fill: "#163300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2181 23.0369H27.5317C25.7884 23.0369 24.3701 21.615 24.3701 19.8675V15.1694C24.3701 13.4218 25.7884 12 27.5317 12H32.2181C33.9613 12 35.3796 13.4218 35.3796 15.1694V19.8675C35.3796 21.615 33.9613 23.0369 32.2181 23.0369ZM27.5317 13.3269C26.5184 13.3269 25.6938 14.1536 25.6938 15.1694V19.8675C25.6938 20.8832 26.5184 21.7099 27.5317 21.7099H32.2181C33.2313 21.7099 34.0559 20.8832 34.0559 19.8675V15.1694C34.0559 14.1536 33.2313 13.3269 32.2181 13.3269H27.5317Z",
    fill: "#163300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4749 47.332H15.6318V39.4692C15.6318 37.3494 17.3519 35.625 19.4665 35.625H25.9835V29.0892C25.9835 26.9694 27.7035 25.245 29.8181 25.245H36.3212V18.7257C36.3212 16.606 38.0413 14.8816 40.1558 14.8816H47.9991V42.7959C47.9991 45.2971 45.9693 47.332 43.4742 47.332H43.4749ZM16.9555 46.0051H43.4742C45.2393 46.0051 46.6755 44.5653 46.6755 42.7959V16.2085H40.1558C38.7713 16.2085 37.6448 17.3378 37.6448 18.7257V26.572H29.8181C28.4335 26.572 27.3071 27.7012 27.3071 29.0892V36.952H19.4665C18.0819 36.952 16.9555 38.0812 16.9555 39.4692V46.0051Z",
    fill: "#163300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project_icon.c5c0f6c258d69415b7df6d73f6daf82e.svg";
export { ForwardRef as ReactComponent };